var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCouponPayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E79",
    fillRule: "evenodd",
    d: "M29.54 28.325h-5.422v-7.282h2.002v5.621h3.42c.515 0 .95-.161 1.31-.484.36-.33.54-.726.54-1.188v-7.139h1.99v7.139c0 .924-.37 1.712-1.11 2.365-.756.645-1.667.968-2.73.968zM13.45 30.008h2.111v-2.112h-2.112v2.112zm-.002-4.224h2.113v-2.112h-2.113v2.112zm0-4.224h2.113v-2.112h-2.113v2.112zm.002-4.224h2.111v-2.112h-2.112v2.112zm14.101 2.376a.68.68 0 0 0-.495-.209h-4.62v8.822h-2.012V17.853h6.633c.74 0 1.374.227 1.902.682.527.462.793 1.012.793 1.65v4.994h-2.004v-4.994a.622.622 0 0 0-.197-.473zM7.111 11c-.587 0-1.084.209-1.495.627-.41.411-.615.906-.615 1.485V32.12c0 .587.204 1.085.614 1.496.412.411.91.616 1.497.616h5.28c.293 0 .543-.103.748-.308l1.364-1.364 1.364 1.364a.996.996 0 0 0 .748.308H36.68a2.02 2.02 0 0 0 1.483-.616c.42-.411.628-.909.628-1.496V13.112c0-.579-.209-1.074-.628-1.485A2.004 2.004 0 0 0 36.681 11H16.616c-.293 0-.543.106-.748.319l-1.364 1.364-1.364-1.364a1 1 0 0 0-.748-.319h-5.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouponPayBlue);
export default __webpack_public_path__ + "static/media/icon-coupon-pay-blue.781cabc472b4b0f57c25fb4c5220ae27.svg";
export { ForwardRef as ReactComponent };